/**
 * Sets a value at a specified path in an object.
 *
 * @param obj - The object to modify.
 * @param path - The path where the value should be set. Use dot notation for nested properties.
 * @param value - The value to set at the specified path.
 * @returns The modified object.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setAt = (obj, path, value) => {
    const keys = path.split('.');
    const lastKey = keys.pop();
    if (!lastKey)
        return obj;
    // biome-ignore lint/suspicious/noAssignInExpressions: suggested fix breaks the app :(
    const lastObj = keys.reduce((acc, key) => (acc[key] = acc[key] || {}), obj);
    lastObj[lastKey] = value;
    return obj;
};
/**
 * Retrieves the value at a given path in an object.
 *
 * @param obj - The object to retrieve the value from.
 * @param path - The path to the value in dot notation (e.g., "property.subproperty").
 * @returns The value at the specified path, or `undefined` if the path does not exist.
 */
export const getAt = (obj, path) => {
    const keys = path.split('.');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return keys.reduce((acc, key) => (!!acc && key in acc ? acc[key] : undefined), obj);
};
/**
 * Deletes the value at a specified path in an object.
 *
 * @param obj - The object to modify.
 * @param path - The path where the value should be deleted. Use dot notation for nested properties.
 * @returns The modified object.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteAt = (obj, path) => {
    const parts = path.split('.');
    const last = parts.pop();
    if (!last)
        return obj;
    const parent = parts.reduce((acc, part) => acc?.[part], obj);
    if (parent && last in parent) {
        delete parent[last];
    }
    return obj;
};
